import { OptionType } from '@evinced-private/ui-common';

import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';

import { extractLabelKey } from '../../shared/helpers';

/**
 * Extract labels that exist on test rows (for removal)
 * Only includes labels actually present on the tests
 * Results are sorted alphabetically
 */
export const extractExistingLabels = (testRows: IWebSdkTest[]): OptionType[] => {
	if (!testRows?.length) {
		return [];
	}

	const uniqueLabels = new Set<string>();
	testRows.forEach((row: { labels?: string[] }) => {
		const labels = row?.labels ?? [];
		labels.forEach((label: string) => {
			if (extractLabelKey(label)) {
				uniqueLabels.add(label);
			}
		});
	});

	return [...uniqueLabels]
		.map((label) => ({ value: label, label }))
		.sort((a, b) => a.label.localeCompare(b.label));
};
